//https://www.html5rocks.com/en/tutorials/forms/constraintvalidation/#toc-current-implementation-issues

export default (function () {
    var init = function () {
        const textBoxes = document.querySelectorAll("[data-on-error-message]");        
        const textBoxCount = textBoxes.length;        

        if (textBoxCount < 1) {
            return;
        }

        for (var i = 0; i < textBoxCount; i++) {
            
            textBoxes[i].addEventListener("invalid", onInvalidTextBox);
            textBoxes[i].addEventListener("input", onInput);
        }       
    };


    function onInvalidTextBox() {
        const textBox = this;
        const message = textBox.dataset.onErrorMessage; 
        if (!textBox.validationMessage.includes(message)) {
            textBox.setCustomValidity(textBox.validationMessage + " " + message);
        }  
    }

    function onInput() {
        const textBox = this;    
        textBox.setCustomValidity('');
    }

    return {
        init: init
    };
})();